import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './EvCategoriesEditor.html?raw';
import Edit from '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import MultiLangEdit from '../../../moreCore/UI/MultiLangEdit/MultiLangEdit';

class EvCategoriesBase extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    evc_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    //evc_Input_Description: Edit = new Edit();
    evc_Input_Description_MultiLang: MdsLax<InstanceType<typeof MultiLangEdit<MainCatalogTypes.EvCategories_LoadData>>>;
    evc_Input_Note: MdsLax<InstanceType<typeof Edit>>;
    evc_Input_TextColor: HTMLInputElement;
    evc_Input_BackgroundColor: HTMLInputElement;
    evc_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    formData: MainCatalogTypes.EvCategories_SaveData = {
        ID: "",
        is_new_status: null,
        code: "",
        description: "",
        note: "",
        order: null,
        coloration: null,
        __multilang: {}
    };

    prepareFormData(data?: MainCatalogTypes.EvCategories_LoadData): void {

        if (data) {

            this.evc_Input_Code.setValue(data.code, true);
            this.evc_Input_Description_MultiLang.setValue({ entity: data, targetAttribute: "description" });
            //this.evc_Input_Description.setValue(data.description, true);
            this.evc_Input_Note.setValue(data.note, true);

            this.evc_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.evc_Input_BackgroundColor.value = data.coloration.BackColor.Hex;

            this.evc_Input_Order.setValue(data.order, true);

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.evc_Input_Code.setValue("", true);
            //this.evc_Input_Description.setValue("", true);
            this.evc_Input_Description_MultiLang.setValue({ entity: null, targetAttribute: "description" });
            this.evc_Input_Note.setValue("", true);

            this.evc_Input_BackgroundColor.value = "#ffffff";
            this.evc_Input_TextColor.value = "#000000";

            this.evc_Input_Order.setValue(null, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData();
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(): void {

        this.formData.code = this.evc_Input_Code.getValue();
        //this.formData.description = this.evc_Input_Description.getValue();
        //this.formData.__multilang["description"] = this.evc_Input_Description_MultiLang.getValue();
        this.evc_Input_Description_MultiLang.getValueOntoEntity(this.formData as any);
        this.formData.note = this.evc_Input_Note.getValue();

        this.formData.order = this.evc_Input_Order.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.evc_Input_TextColor.value;
        let backHex = this.evc_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        console.debug("SERIALIZED DATA", this.formData);
    }

    _onChangeServiceCategoryInputData(): void {

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeInputNoteData(): void {

        this.fixNewLineInMultilineEdit(this.evc_Input_Note);

        this.serializeFormData();
        this.checkDirty();
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.code) b = false;

        //if (!this.formData.description) b = false;

        return b;
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this.entityClass = MainCatalogs_Classes.ServiceCategory;

        this.evc_Input_Code.setMaxLength(10);
        //this.evc_Input_Description.setMaxLength(255);
        this.evc_Input_Note.setMaxLength(2000);
        this.evc_Input_Note.setValidationEnabled(false);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(EvCategoriesBase.prototype, {
  evc_Input_Code: () => (new Edit()),
  evc_Input_Note: () => (new Edit()),
  evc_Input_Order: () => (new NumberInput()),
});
export default mdsWidget(EvCategoriesBase);